import React, { FunctionComponent } from 'react';
import { ApolloError, DocumentNode } from 'apollo-boost';
import { pathOr } from 'ramda';
import { Grid } from 'semantic-ui-react';
import withStyles from 'react-jss';
import moment from 'moment';

import Query from 'components/Query';
import { CNStatusCardsPlaceholder } from 'components/Placeholder';
import { ClassProp } from 'helpers/types';

import CardNetworkStatusCards from './components/CardNetworkStatusCards';
import { CardNetworkStatus } from './components/CardNetworkStatusCards/CardNetworkStatusCards';

const styles = {
  container: {
    margin: '0 !important',
  },
  containerRow: {
    padding: '0 !important',
  },
};

export type StatsAboutRetrievalJobs = {
  quantity: number;
  dateOfOldest: Date;
};

export type StatsAboutRetrievalJobsWaitingForExport = {
  [cardNetwork: string]: StatsAboutRetrievalJobs;
};

type QueryResponse = {
  data: {
    cardNetworkStatus: CardNetworkStatus;
    getStatsAboutRetrievalJobsWaitingForExport?: StatsAboutRetrievalJobsWaitingForExport;
  };
  loading?: boolean;
  error?: ApolloError;
};

type Props = {
  classes: ClassProp<typeof styles>;
  query: DocumentNode;
  params: {
    cardNetwork?: string;
    merchantId?: string;
    venueUuid?: string;
  };

  showActions?: boolean;
};

const endDate = moment().subtract(7, 'days').format('YYYY-MM-DD');

const startDate = moment(endDate).subtract(7, 'days').format('YYYY-MM-DD');

const renderCardNetworkStatusCards = (
  classes: ClassProp<typeof styles>,
  showActions = false,
) => (response: QueryResponse) => {
  const cardNetworkStatus = pathOr(
    [],
    ['data', 'cardNetworkStatus'],
    response,
  ) as CardNetworkStatus;

  const statsAboutRetrievalJobs = pathOr(
    {},
    ['data', 'getStatsAboutRetrievalJobsWaitingForExport'],
    response,
  );

  return (
    <Grid columns="equal" className={classes.container}>
      <Grid.Row className={classes.containerRow}>
        {response.loading ? (
          <>
            <CNStatusCardsPlaceholder />
            <CNStatusCardsPlaceholder />
            <CNStatusCardsPlaceholder />
          </>
        ) : (
          <CardNetworkStatusCards
            showActions={showActions}
            cardNetworkStatus={cardNetworkStatus}
            statsAboutRetrievalJobs={statsAboutRetrievalJobs}
          />
        )}
      </Grid.Row>
    </Grid>
  );
};

const CNStatusSection: FunctionComponent<Props> = ({
  classes,
  params,
  query,
  showActions,
}) => (
  <Query
    enableProgressInfo
    query={query}
    variables={{
      params: {
        startDate,
        endDate,
        ...params,
      },
    }}
    render={renderCardNetworkStatusCards(classes, showActions)}
  />
);

export default withStyles(styles)(CNStatusSection);
